module.exports = __webpack_public_path__ + "static/media/logo-faktura-assist-footer.6c52a43a.svg";